import { scrollbar } from "src/styles/mixins";
import styled from "styled-components";

export const NewTaskPanelWrapper = styled.div<{ isVisible: boolean }>`
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
`;

export const NewTaskNameWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  border: ${({ theme }) =>
    `${theme.border.thin} solid ${theme.colors.primary}`};
  border-radius: ${({ theme }) => `${theme.borderRadius.l}`};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 84px;
  margin-bottom: 10px;

  padding: 14px 20px 17px 20px;
`;

export const NewTaskNameTextArea = styled.textarea`
  border: none;
  flex: 1;
  text-align: flex-start;
  outline: none;

  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};

  ${scrollbar}
`;

export const NewTaskPanelButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 25px;

  button {
    width: 100%;
  }
`;
